import { NavigationHttpService } from '@httpServices'
import { IMenuPaths } from '@interfaces'
import { resolveDrupalMenuLink } from '@utils'

export const NavigationService = {
  /**
   * Get nav items
   */
  getNavItems: async (locale: string): Promise<IMenuPaths[]> => {
    const MENU_PATHS = []

    try {
      const navItems = await NavigationHttpService.getNavItems(locale)

      navItems.forEach((nav) => {
        const { path, isExternal } = resolveDrupalMenuLink(nav)

        const preparedMainNavItem = {
          id: nav?.key || '',
          path,
          labelTx: nav?.title || '',
          isExternal,
          subMenu: [],
          bgImage: nav?.description || '/img/nav/visit.jpg',
        }
        if (
          nav?.below &&
          typeof nav?.below === 'object' &&
          nav?.below.length > 0
        ) {
          const SUB_MENU_PATHS = []

          nav?.below.forEach((subItem) => {
            const subNavLink = resolveDrupalMenuLink(subItem)

            const subNavItem = {
              id: subItem?.key || '',
              path: subNavLink.path,
              labelTx: subItem?.title || '',
              isExternal: subNavLink.isExternal,
              isPwaLink: subItem?.description === 'isPWA' || false,
            }

            SUB_MENU_PATHS.push(subNavItem)
          })

          preparedMainNavItem.subMenu = SUB_MENU_PATHS
        }

        MENU_PATHS.push(preparedMainNavItem)
      })
    } catch (error) {
      console.log({ navigationError: error })
    }

    return MENU_PATHS
  },
}
